//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import KirbyLink from './kirbylink.vue'
export default {
    name: "thefrmstory",
    props:{
      content: Object
    },
    components:{
      KirbyLink
    }
}
